import styled from 'styled-components'

export const HR = styled.hr`
  border: 0px;
  border-top: 1px solid rgb(224, 224, 224);
`
